module.exports = __webpack_public_path__ + "static/img/Seven of Swords.b347a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Seven of Swords.jpg
// module id = 1297
// module chunks = 0